import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const FORM_SYS_ROUTES = {
  index: '/form-sys',
  createFormTemplate: '/form-sys/form-template',
  editFormTemplate: '/form-sys/form-template/$id',
  formTemplateManagement: '/form-sys/form-template-management',
  formTemplate: '/form-sys/form-templates/$id',
  createFormRuntime: '/form-sys/create-form/$templateId',
  editFormRuntime: '/form-sys/form-runtime/$id',
  formRule: '/form-sys/form-rule',
  customWidgetManager: '/form-sys/custom-widget-manager',
  formApplication: '/form-sys/form-application',
  runtimeFormTodo: '/form-sys/runtime-form-todo',
  formTemplateVersion: '/form-sys/form-template-version/$id',
} as const;

export const FORM_SYS_ROUTE_IDS = {
  createFormTemplate: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.createFormTemplate}`,
  editFormTemplate: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.editFormTemplate}`,
  formTemplateManagement: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.formTemplateManagement}`,
  formApplication: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.formApplication}`,
  runtimeFormTodo: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.runtimeFormTodo}`,
  formTemplateVersion: `/${AUTH_ROUTE_ID}${FORM_SYS_ROUTES.formTemplateVersion}`,
} as const;
